require('selection/selection');
require('property/search');

window.addEventListener('message', receiveMessage, false);
function receiveMessage(event) {
    if (event.data === 'unlock') {
        $('html,body').animate({scrollTop: $('#estimation-iframe').offset().top}, 0);
    } else {
        $('#estimation-iframe').height(event.data);
    }
}



var formControls = require('form/controls');

$('.fancybox').fancybox();

$('.top-link--a').on('click',function(){
    $('html, body').animate({
     'scrollTop':   $('html').offset().top
 }, 500);
    return false;
});

$('#trigger-overlay').on('click',function() {
    $('.overlay-door').css({
        "z-index": 10000
    });
    $('.overlay-door').animate({
        opacity: 1
    }, 300 );
});
$('.overlay-door .overlay-close').on('click',function() {
    $('.overlay-door').animate({
        opacity: 0
    }, {
        duration: 300,
        complete: function() {
            $('.overlay-door').css({"z-index": -1});
        }
    });
});

/*Alignement*/
function sameHeight(selector){
    var elements = document.querySelectorAll(selector);
    var content = document.querySelectorAll(selector);
    var h = 0;

    Array.prototype.forEach.call(elements, function(el, i){
        if (el.offsetHeight > h)
            h = el.offsetHeight;
    });
    Array.prototype.forEach.call(content, function(el, i){
        if(h != 0){
            el.style.height = h+'px';
        }
    });
}

$(window).load(function() {
    if (window.innerWidth > 992) {
     sameHeight('.height-prop');

 };
 if (window.innerWidth > 768) {
    sameHeight('.height-cons');
    sameHeight('.news-sh');
    sameHeight('.notices-sh');
    sameHeight('.services-sh');
    sameHeight('.subpages-gal-sh');
};
if (window.innerWidth < 480) {
    $('#engineMobCouns').append($('#counsellorSearch'));
};
})

window.mobileAndTabletcheck = function() {
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
}

/* repere temoignage */
if(window.location.hash == "#temoignages"){
    $('html, body').animate({
        'scrollTop':   $('#notice').offset().top
    }, 500);
}

// $(window).load(function () {

//     var wow = new WOW({
//         animateClass: 'animated',
//         callback: function(box) {
//         }
//     });
//     wow.init();
// })

$( document ).ready(function() {
    var wow = new WOW({
        animateClass: 'animated',
        callback: function(box) {
        }
    });
    wow.init();
});



window.getURLParameters = function(){
    var urlParametersAsString = window.location.search.substring(1);
    var urlParameters =  urlParametersAsString.split("&");
    return urlParameters;
}

window.getURLParameter = function(param){
    urlParameters = getURLParameters();
    for (var i = 0; i < urlParameters.length; i++) 
    {
        var currentParam = urlParameters[i].split('=');
        if (currentParam[0] == param) 
        {
            return currentParam[1];
        }
    }
}

window.setUrlParameter = function(paramName,paramValue){
    setUrlParameters([{
        name: paramName,
        value: paramValue
    }]);
}

window.setUrlParameters = function(tabParams){
    urlParameters = getURLParameters();
    newHref = "?";
    
    for(p in tabParams){
        tabParams[p].isNew = true;
    }

    for(var i = 0;i < urlParameters.length; i++){
        var currentParam = urlParameters[i].split('=');
        currentParamName = currentParam[0];
        currentParamValue = currentParam[1];

        for(p in tabParams){
            paramName = tabParams[p].name;
            paramValue = tabParams[p].value;
            if(currentParamName == paramName){
                currentParamValue = paramValue;
                tabParams[p].isNew = false;
            }
        }

        if(newHref !== "?"){
            newHref += "&";
        }

        if(currentParamName){
            newHref += currentParamName + "=" + currentParamValue
        }
    }


    for(p in tabParams){
        paramName = tabParams[p].name;
        paramValue = tabParams[p].value;
        isNew = tabParams[p].isNew;
        if(isNew && newHref !== '?'){
            newHref += "&";
        }
        if(newHref === '?' || isNew){
            newHref += paramName+"="+paramValue;
        }
    }

    newHref = encodeURI(newHref);
    
    window.location.href = window.location.pathname + newHref + "#biensPrestige";
}


var onClickSearchRegionBtn = function(e){
    e.preventDefault();

    var url = "/acheter/"
    var options = $('option','#typeSelect');
    var first = true;
    
    for(var i=0;i<options.length;i++){
        var current = options[i];
        var currentValue = $(current).attr('value');
        if(currentValue){
            if(!first){
                url += "-";
            }
            url += currentValue;
            first = false;
        }
    }

    var region = $(this).data('region');
    url += "/" + region + "/";  

    
    window.location.href = url;
}

$(document).ready(function(){
    $('a.consd-prestige-infosbar-contact').click(function() {
        var target = $(this.hash);
        if(window.innerWidth > 479) {
            $('html, body').animate({ scrollTop: target.offset().top-160 }, 500);
        };
        if(window.innerWidth < 480) {
            $('html, body').animate({ scrollTop: target.offset().top-60 }, 500);
        };
        return false;
    });
    $('.consd-infosbar-contact a').click(function() {
        var target = $(this.hash);
        if(window.innerWidth > 479) {
            $('html, body').animate({ scrollTop: target.offset().top-60 }, 500);
        };
        if(window.innerWidth < 480) {
            $('html, body').animate({ scrollTop: target.offset().top-40 }, 500);
        };       
        return false;
    });

});

/*if (window.matchMedia("(min-width: 992px)").matches) {
    if (window.scrollY > 0) {
        $('nav.nav').addClass('scrolled');
        $('.header').addClass('scrolled');
    }else{
        $('nav.nav').removeClass('scrolled');
        $('.header').removeClass('scrolled');
    }
}*/

$(window).scroll(function() {    

    if (!$("body").hasClass("search-opened")) {

        var scroll = $(window).scrollTop();

        if (scroll > 0) {
            //$('nav.nav').addClass('scrolled');
            //$('.header').addClass('scrolled');
            //$('.header-prestige').addClass('scrolled');
            // $('.aside').addClass('scrolled');
            $('.engine-aside-search').addClass('scrolled');
        }else{
            //$('nav.nav').removeClass('scrolled');
            //$('.header').removeClass('scrolled');
            //$('.header-prestige').removeClass('scrolled');
            // $('.aside').addClass('scrolled');
            $('.engine-aside-search').removeClass('scrolled');
        }
    }else{
        //$('nav.nav').removeClass('scrolled');
        //$('.header').removeClass('scrolled');
        //$('.header-prestige').removeClass('scrolled');
        // $('.aside').addClass('scrolled');
        $('.engine-aside-search').removeClass('scrolled');
    }
});